import axios from "axios"
import Cookie from "js-cookie"

axios.defaults.headers["Content-Type"] = "application/json"

// 创建axios实例
const service = axios.create({
	// axios中请求配置有baseURL选项，表示请求URL公共部分
	baseURL: process.env.NODE_ENV == "development" ? "/api" : "/prod-api",
	// 超时
	timeout: 10000,

})
// request拦截器
service.interceptors.request.use(config => {
	let token = window.sessionStorage.getItem("token");
	if (token && !config.url.startsWith("/loginSan")) {
		config.headers.Authorization = "Bearer " + token
	}
	// get请求映射params参数
	if (config.method === "get" && config.params) {
		let url = config.url + "?";
		for (const propName of Object.keys(config.params)) {
			const value = config.params[propName];
			var part = encodeURIComponent(propName) + "=";
			if (value !== null && typeof (value) !== "undefined") {
				if (typeof value === "object") {
					for (const key of Object.keys(value)) {
						if (value[key] !== null && typeof (value[key]) !== "undefined") {
							let params = propName + "[" + key + "]";
							let subPart = encodeURIComponent(params) + "=";
							url += subPart + encodeURIComponent(value[key]) + "&";
						}
					}
				} else {
					url += part + encodeURIComponent(value) + "&";
				}
			}
		}
		url = url.slice(0, -1);
		config.params = {};
		config.url = url;
	}
	return config
}, error => {
	console.log(error)
	Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
		return res.data
	},
	error => {
		console.log("err" + error)

		return Promise.reject(error)
	}
)

export default service